/**
 * Interactivity for the Quicklinks menu widget.
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

(function ($) {
  'use strict';

  // Close button element.
  let $closer;
  // Main quicklinks element.
  let $quicklinks;
  // Pixel height of the menu items.
  let listHeight;

  Drupal.behaviors.initializeQuickLinks = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Closes the Quicklinks menu.
   */
  function handleClose(e) {
    // So we don't also fire events attached below.
    e.stopPropagation();
    $quicklinks.removeClass('is-active');
    $quicklinks.height('');

    $closer.off('click', handleClose);
    $quicklinks.on('click', handleOpen);
  }

  /**
   * Open the Quicklinks menu.
   */
  function handleOpen(e) {
    // So we don't also fire events attached below.
    e.stopPropagation();
    $quicklinks.addClass('is-active');
    $quicklinks.height(listHeight);

    $closer.on('click', handleClose);
    $quicklinks.off('click', handleOpen);
  }

  /**
   * Cache elements, initialize variables, attach event handlers.
   */
  function initialize() {
    $quicklinks = $('#block-quicklinks');

    // No Quicklinks on the page, get out now!
    if (!$quicklinks.length) return false;

    $closer = $('#quicklinks-close-button');
    listHeight = $('> ul', $quicklinks).outerHeight();
    $quicklinks.on('click', handleOpen);
  }
})(jQuery);
